import type { QueryClient } from '@tanstack/react-query';
import type { useTRPC } from '../trpc.js';

/**
 * Asks again for everything showing a fund's row: the funds' own reads, and the
 * lists, whose answers carry the rows of the funds on them.
 */
export function invalidateFundRows(
  queryClient: QueryClient,
  trpc: ReturnType<typeof useTRPC>,
): void {
  void queryClient.invalidateQueries(trpc.funds.pathFilter());
  void queryClient.invalidateQueries(trpc.lists.get.pathFilter());
}
